// @flow

import ActionTypes from "../constants/ActionTypes";
import API from "../api/";

const fetchTagsCounterRequest = (): any => ({
    type: ActionTypes.FETCH_TAGS_COUNTER_REQUEST,
});

const fetchTagsCounterSuccess = (tags: any): any => ({
    type: ActionTypes.FETCH_TAGS_COUNTER_SUCCESS,
    tags,
});

const fetchTagsCounterFail = (error: any): any => ({
    type: ActionTypes.FETCH_TAGS_COUNTER_FAIL,
    error,
});

export function setTagsCounter(tags: Object): any {
    return {
        type: ActionTypes.SET_TAGS_COUNTER,
        tags,
    };
}

export const fetchTagsCounter =
    (): any =>
    (dispatch: any): Promise<any> => {
        dispatch(fetchTagsCounterRequest());
        return API.fetchTagsCounter()
            .then((data: any): any => {
                dispatch(fetchTagsCounterSuccess(data));
                return data;
            })
            .catch((error: any): any => {
                dispatch(fetchTagsCounterFail(error));
                throw error;
            });
    };
